import {
    apiRequest,
    getSimantab
} from "../../../../../services/adapters/kepegawaian/skpService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", getSimantab, {
            params: query
        }, true)
    }
}

export default DetailRepository